import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';

import { setPanelWidth } from '@reducers/options/panel/actions';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import Panel from '@scene/objects/panel';

const Lx = props => {
  if (props.panelType !== Panel.types.CUSTOM) {
    return (
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_LX.Content}>
        <Input
          prefix="Lx ="
          postfix={unitLabel(props.unit)}
          id="width"
          type="number"
          minValue={0}
          className="base-plate__input_block"
          disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
          value={props.width}
          onUpdate={value => {
            props.setWidth(value, props.unit);
          }}
        />
      </Tooltip>
    );
  }

  return null;
};

const mapState = state => {
  const unit = state.main.units.distance;

  return {
    panelType: state.options.panel.type,
    width: unitTransform(state.options.panel.width || 0).from(defaultUnits.DISTANCE).to(unit),
    unit,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
  };
};

const mapDispatch = dispatch => ({
  setWidth: (value, unit) => dispatch(setPanelWidth(unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE))),
});

export default connect(mapState, mapDispatch)(Lx);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Lx.js